<template>
  <tr>
    <td class="drag-handle text-center align-middle" style="cursor: grab">
      <i class="fas fa-grip-lines"></i>
    </td>
    <td class="text-center align-middle">
      <div>#{{ position }}</div>
    </td>
    <td>
      <div>{{ subcategory.name }}</div>
    </td>
    <td>
      <div v-if="subcategory.category != null">
        {{ subcategory.category.name }}
      </div>
    </td>
    <td>
      <div v-if="subcategory.topic != null">{{ subcategory.topic.name }}</div>
    </td>
    <td class="text-center align-middle">
      <div v-if="subcategory.enabled">
        <span class="badge badge-success">Activado</span>
      </div>
      <div v-else><span class="badge badge-danger">Desactivado</span></div>
    </td>
    <td class="text-center">
      <router-link
        :to="'/app/blog/subcategory/' + subcategory.UUID"
        class="btn btn-outline-dark mb-2"
      >
        <i class="fas fa-edit"></i>
      </router-link>
      <button class="btn btn-outline-danger" @click="deleteSubCategory()">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import SubCategoryService from "@/services/subcategory.service";
import Swal from "sweetalert2";

export default {
  name: "SubCategoryRow",
  props: {
    subcategory: Object,
    topics: Array,
    position: Number,
  },
  methods: {
    async deleteSubCategory() {
      // 1. Updated title and text to show the subcategory name
      const result = await Swal.fire({
        title: '¿Quieres confirmar esta acción?',
        text: `Vas a eliminar la subcategoría: ${this.subcategory.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        try {
          await SubCategoryService.deleteSubCategory(this.subcategory.UUID);
          
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Se ha borrado correctamente.",
            showConfirmButton: false,
            timer: 2500,
            backdrop: false,
            toast: true,
          });

          // 2. Added timeout so the user sees the success toast before refresh
          setTimeout(() => {
            this.$router.go();
          }, 2500);

        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo borrar la subcategoría',
          });
        }
      }
    },
  }
};
</script>